import twitter from './images/icons/iconsContacts/vector_twitter.png';
import telegram from './images/icons/iconsContacts/vector_telegram.png';
import linkedin from './images/icons/iconsContacts/vector_in.png';

const imagesContacts = {
  twitter,
  telegram,
  linkedin,
};

export default imagesContacts;
